import { ErrorBoundary, NavLinks, Notifications, Skeleton, SkeletonHeader } from '@isbj-redesign/shared-components'
import { AuthContext, useAuth } from '@nortal/frontend-auth'
import React, { FC, useMemo } from 'react'
import Footer from './Footer'

export type LayoutProps = {
    title: string
}

const Layout: FC<LayoutProps> = ({ title, children }) => {
    const auth = useAuth()
    const links: NavLinks = useMemo(() => createNavLinks(auth), [auth])

    return (
        <Skeleton fachkontext="Dokumententresor" title={<Title title={title} />} links={links}>
            <ErrorBoundary>{children}</ErrorBoundary>
            <Footer />
        </Skeleton>
    )
}

function createNavLinks(auth: AuthContext): NavLinks {
    const links: NavLinks = {
        hilfe: {
            href: '/onlinehilfe',
            title: 'Online Hilfe',
            external: true,
        },
    }

    if (auth.state === 'authenticated') {
        links.user = {
            title: 'Abmelden',
            onClick: () => auth.signOut(),
        }
    }

    return links
}

const Title = ({ title }: LayoutProps) => (
    <>
        <SkeletonHeader title={title} />
        <Notifications />
    </>
)

export default Layout
